import React from 'react';
import { withNamespaces } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import PayrollFileConfigurationAPI from '../../api/payroll-file-configurations';
import DefaultPayrollFileForm from '../../components/DefaultPayrollFileForm';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import SpaceSpinner from '../../components/SpaceSpinner';
import Toast from '../../components/Toast';
import PageContainer from '../../containers/PageContainer';
import { INTERNAL_LINKS } from '../../enum';
import withAuthentication from '../../hocs/withAuthentication';

const UpdateDefaultPayrollFileView = props => {
  const { t, history, match } = props;

  const queryClient = useQueryClient();

  const payrollFileConfigurationDetailsQuery = useQuery({
    queryKey: ['fetchPayrollFileConfigurationDetails', match.params.id],
    queryFn: () =>
      new PayrollFileConfigurationAPI().fetchPayrollFileConfigurationDetails(match.params.id),
  });

  const updatePayrollFileConfigurationMutation = useMutation(
    data =>
      new PayrollFileConfigurationAPI().updatePayrollFileConfiguration(match.params.id, {
        ...data,
        isGlobal: true,
      }),
    {
      onSuccess: responseData => {
        queryClient.invalidateQueries(['fetchPayrollFileConfiguration', 'isGlobal']);
        queryClient.setQueryData(
          ['fetchPayrollFileConfigurationDetails', match.params.id],
          responseData,
        );
        Toast({
          type: 'success',
          message: t('updateGlobalPayrollFileConfigurationSuccess'),
        });
      },
      onError: () => {
        Toast({
          type: 'error',
          message: t('updateGlobalPayrollFileConfigurationError'),
        });
      },
    },
  );

  const handleSubmit = payload => {
    updatePayrollFileConfigurationMutation.mutate(payload);
  };

  if (payrollFileConfigurationDetailsQuery.isFetching) {
    return <SpaceSpinner />;
  }

  return (
    <PageContainer
      title={
        <PageBreadcrumbs
          items={[
            {
              label: t('globalSettings'),
              onClick: () => history.push(INTERNAL_LINKS.GLOBAL_SETTINGS + '#payrollFile'),
            },
            { label: t('updateDefaultPayrollFile') },
          ]}
        />
      }
    >
      <DefaultPayrollFileForm
        t={t}
        isUpdate
        onSubmit={handleSubmit}
        disabled={updatePayrollFileConfigurationMutation.isLoading}
        loading={updatePayrollFileConfigurationMutation.isLoading}
        initialData={payrollFileConfigurationDetailsQuery.data}
      />
    </PageContainer>
  );
};

export default withNamespaces()(withAuthentication(UpdateDefaultPayrollFileView));
